var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_763_4666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1683 6.66585V4.16585C14.1683 3.94484 14.0805 3.73288 13.9242 3.5766C13.7679 3.42032 13.556 3.33252 13.335 3.33252H5.00163C4.5596 3.33252 4.13568 3.50811 3.82312 3.82067C3.51056 4.13324 3.33496 4.55716 3.33496 4.99919M3.33496 4.99919C3.33496 5.44121 3.51056 5.86514 3.82312 6.1777C4.13568 6.49026 4.5596 6.66585 5.00163 6.66585H15.0016C15.2226 6.66585 15.4346 6.75365 15.5909 6.90993C15.7472 7.06621 15.835 7.27817 15.835 7.49919V9.99919M3.33496 4.99919V14.9992C3.33496 15.4412 3.51056 15.8651 3.82312 16.1777C4.13568 16.4903 4.5596 16.6659 5.00163 16.6659H15.0016C15.2226 16.6659 15.4346 16.5781 15.5909 16.4218C15.7472 16.2655 15.835 16.0535 15.835 15.8325V13.3325",
    stroke: "#B08BFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.665 10V13.3333H13.3317C12.8897 13.3333 12.4658 13.1577 12.1532 12.8452C11.8406 12.5326 11.665 12.1087 11.665 11.6667C11.665 11.2246 11.8406 10.8007 12.1532 10.4882C12.4658 10.1756 12.8897 10 13.3317 10H16.665Z",
    stroke: "#B08BFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_763_4666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4261b28d3e24cf4fde162842f3abfd43.svg";
export { ForwardRef as ReactComponent };